import m from "mithril";
import { store } from "../models/store.js";
import { scan } from "../services/scan.js";

// Two ways in: the camera (capture) and the file picker. On a phone the first
// opens the camera straight away; on a laptop both are just file choosers.

async function onFile(ev: Event) {
  const input = ev.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = ""; // let the same file be chosen twice
  if (!file) return;
  await store.loadImage(file);
  // Kick off a first scan automatically — the whole point is speed.
  void scan(false);
}

export const PhotoInput: m.Component = {
  view() {
    return m("div.photo-input", [
      m("label.btn.btn-primary", [
        "📷 Take photo",
        m("input", {
          type: "file",
          accept: "image/*",
          capture: "environment",
          hidden: true,
          onchange: onFile,
        }),
      ]),
      m("label.btn", [
        "🖼️ Choose image",
        m("input", {
          type: "file",
          accept: "image/*",
          hidden: true,
          onchange: onFile,
        }),
      ]),
    ]);
  },
};
